import { createFileRoute } from '@tanstack/react-router';

import { RfqsPage } from '@/features/procurement/rfqs-page';

export const Route = createFileRoute('/_app/projects/$projectId/procurement/rfqs/')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <RfqsPage {...params} />;
}
